"use strict";
import { useCallback, useEffect } from "react";
import { FORCE_CLASSIC_ROUTING, getEnforcedRouterPreference, ROUTING_CONFIG_MESSAGE } from "constants/routing";
import { RouterPreference } from "state/routing/types";
import { useRouterPreference } from "state/user/hooks";
export function useUniversalRouterOnly() {
  const [routerPreference, setRouterPreference] = useRouterPreference();
  useEffect(() => {
    if (FORCE_CLASSIC_ROUTING && routerPreference !== getEnforcedRouterPreference()) {
      setRouterPreference(getEnforcedRouterPreference());
    }
  }, [routerPreference, setRouterPreference]);
  const enforceClassicRouting = useCallback(() => {
    setRouterPreference(getEnforcedRouterPreference());
  }, [setRouterPreference]);
  return {
    isClassicRouting: routerPreference === RouterPreference.API,
    enforceClassicRouting,
    configMessage: ROUTING_CONFIG_MESSAGE,
    isForced: FORCE_CLASSIC_ROUTING
  };
}
